import { HttpClient } from '@airship-platform/http-service';
import { createContext, PropsWithChildren, useContext } from 'react';

interface HttpContextProps {
  httpClient: HttpClient;
}

const HttpContext = createContext<HttpContextProps | undefined>(undefined);

export const HttpProvider: React.FC<PropsWithChildren<HttpContextProps>> = ({
  children,
  httpClient,
}) => (
  <HttpContext.Provider value={{ httpClient }}>{children}</HttpContext.Provider>
);

export const useHttpClient = (): HttpClient => {
  const context = useContext(HttpContext);
  if (!context) {
    throw new Error('useHttpClient must be used within a HttpProvider');
  }
  return context.httpClient;
};

export const delayWithAbort = (delayMs: number, signal: AbortSignal) =>
  new Promise((resolve) => {
    const timeoutId = setTimeout(
      resolve,
      Math.ceil(delayMs + Math.random() * 250)
    );

    const abortHandler = () => {
      clearTimeout(timeoutId);
      resolve(undefined);
      signal.removeEventListener('abort', abortHandler);
    };
    signal.addEventListener('abort', abortHandler);
  });
